import { render, staticRenderFns } from "./HumanCell.vue?vue&type=template&id=32e84a68&scoped=true&"
import script from "./HumanCell.vue?vue&type=script&lang=js&"
export * from "./HumanCell.vue?vue&type=script&lang=js&"
import style0 from "./HumanCell.vue?vue&type=style&index=0&id=32e84a68&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e84a68",
  null
  
)

export default component.exports